import PropTypes from 'prop-types';
import React from 'react';

const PrintableSummary = ({summary, columns, date, since, sinceMessage, title, dateLabel}) => {
  return (
    <div>
      <div className='row well' style={{padding: '20px 0px', margin: '10px 0px'}}>
        <div className='col-sm-12'>
          <label style={{fontSize: '20px'}}>{title}</label>
        </div>
        <div className='col-sm-3'>
          <label>{dateLabel ? dateLabel : 'Date'}</label>
          <div> {date} </div>
        </div>
        { sinceMessage && since ? <div className='col-sm-3'>
          <label>{sinceMessage}</label>
          <div> {since} </div>
        </div> : null}
      </div>
      <div className='row well' style={{padding: '20px 0px', margin: '10px 0px'}}>
        {
          columns.map(c => {
            return (
              <div key={c.key} className='col-sm-3' style={{padding: '0 0 10px 0'}}>
                <label>{c.name}</label>
                <div> {summary[c.key]} </div>
              </div>
            );
          })
        }
      </div>
    </div>
  );
};

PrintableSummary.propTypes = {
  summary: PropTypes.any.isRequired,
  columns: PropTypes.array.isRequired,
  date: PropTypes.string.isRequired,
  since: PropTypes.string,
  sinceMessage: PropTypes.string,
  dateLabel: PropTypes.string,
};

export default PrintableSummary;
